import * as React from "react";
import { useTopicWithRefresh } from "--client/common/data/PeopleHooks";
import { useLoggedInUser } from "--client/common/hooks/useLoggedInUser";
import { DisplayNameFromID } from "--floponents-web/atoms/DisplayName/DisplayNameFromID";
import { TopicKey, TopicValue } from "--client/../static_types/topic.types";
import styled, { css } from "styled-components";
import { seededRandomColorSet } from "--client/../components/theme";
import { TopicUtils } from "--client/../utils/TopicUtils";
import { FIXMe } from "--client/../utils/dev";

export const StyledTopicDisplayName = styled.span<{ colorSeed?: string, type?: "space" | "dm" | "stream" | "org" | undefined, variant?: "chip" }>`
	color: ${props =>
        props.variant === "chip"
            ? props.theme.palette.white
            : props.colorSeed === undefined ? "unset"
                : seededRandomColorSet(props.colorSeed).main
    };
    background-color: ${props => props.variant === "chip" && props.type
        ? (props.type === "space" || props.type === "org" || props.type === "dm") && props.colorSeed ?
            seededRandomColorSet(props.colorSeed).main :
            props.theme.palette.positive.darker
        : "unset"
    };
    ${p => p.variant === "chip" ? css`border-radius:${p.theme.radius.small};` : ""}
    ${props => props.onClick ? css`cursor:pointer;` : ""}
`


export const TopicDisplayNameFromID: React.FC<{ onClick?: () => void, id: string, includePrefix?: boolean, colourize?: boolean, variant?: "chip", topic?: TopicKey & TopicValue }> = props => {
    const [topic] = useTopicWithRefresh(props.id);
    if (!topic) return <></>
    return <TopicDisplayNameFromTopic onClick={props.onClick} colourize={props.colourize} includePrefix={props.includePrefix} topic={topic} variant={props.variant} />
}

export const TopicDisplayNameFromTopic: React.FC<{ onClick?: () => void, colourize?: boolean, className?: string, variant?: "chip", topic?: TopicKey & TopicValue, includePrefix?: boolean }> = props => {
    const topic = props.topic;
    const user = useLoggedInUser();
    const type = topic?.type;
    const prefix = props.includePrefix ? <TopicPrefix topic={topic} /> : null
    if (type?.name === "dm") {
        FIXMe("anytime", "Cloud users can't have dms, this is an issue on click through that tries to create one maybe?");
        const other_user = user.type === "internal"
            ? TopicUtils.GetDMOtherParty(type, user.user_id)
            : undefined

        if (other_user) {
            return <StyledTopicDisplayName
                colorSeed={props.colourize ? other_user.type === "user" ?
                    other_user.user_id
                    : topic?.name : undefined}
                className={props.className}
                variant={props.variant}
                onClick={props.onClick}
                type={(props.colourize || props.variant === "chip") && type.name || undefined}>
                {prefix}
                {
                    other_user.type === "user"
                        ? <DisplayNameFromID userId={other_user.user_id} />
                        : topic?.name
                }
            </StyledTopicDisplayName>
        }
        return <>??</>
    }
    else if (type?.name === "stream" && type.subtype === "spaceDM") {
        const isUser = type.people.includes(user.user_or_identity_id);
        const dmUser = type.people.at(0);
        return <StyledTopicDisplayName
            colorSeed={props.colourize ? isUser ? type.space_id : dmUser : undefined}
            variant={props.variant}
            type={props.colourize ? isUser ? "dm" : type.name : undefined}
            {...(isUser ? props : undefined)}
        >
            {prefix}{isUser ? <TopicDisplayNameFromID id={type.space_id} /> : dmUser ? <>
                <TopicDisplayNameFromID id={type.space_id} />&nbsp;&lt;-&gt;&nbsp;
                <DisplayNameFromID userId={dmUser} includePrefix={props.includePrefix} />
            </> : null}
        </StyledTopicDisplayName>
    } else {
        return <StyledTopicDisplayName colorSeed={props.colourize ? props.topic?.id : undefined} variant={props.variant} type={props.colourize && type?.name || undefined}>{prefix}{topic?.name}</StyledTopicDisplayName>
    }
}
export const TopicPrefix: React.FC<{ topic?: TopicValue }> = props => {
    const topic = props.topic;
    if (topic?.type.name === "org" || topic?.type.name === "space" || topic?.type.name === "dm" || (topic?.type.name === "stream" && topic.type.subtype === "spaceDM")) return <>@</>;
    if (topic) return <>#</>;
    return <> </>;
}